import { NgModule } from '@angular/core';
// import { FirebaseX } from '@awesome-cordova-plugins/firebase-x/ngx';
// import { Firebase } from '@awesome-cordova-plugins/firebase/ngx';

@NgModule({
  providers: []
  //[Firebase, FirebaseX],
})
export class NativeFirebaseModule {
}
